import { render } from "./index.vue?vue&type=template&id=6add5d20&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6add5d20&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6add5d20"

export default script